module.exports = __webpack_public_path__ + "img/search-header-nav-below-ford.527fc9a5.png";